module.exports = __webpack_public_path__ + "static/media/result_rs_ja_old.8765a216.jpg";